import { placeOrderApi } from './api/placeOrderApi'
import { PlaceOrderService } from './service/PlaceOrderService'

export const placeOrderService = new PlaceOrderService(placeOrderApi)
